<template>
    <button :class="['btn action-btn',
                active ? 'state-active' : '',
                flex ? 'd-flex align-items-center justify-content-left' : 'd-inline'
            ]"
            name="clear"
            :disabled="disabled"
            @click="$emit('click')">
        <slot></slot>
        <icon :name="icon"></icon>
        <span class="button-title">{{buttonTitle}}</span>
    </button>
</template>

<script type="text/babel">
import Icon from '../../../../../Shared/Icons/Icon.vue';

export default {
    name: 'TemplateEditorButton',
    components: {Icon},
    props: {
        buttonTitle: {
            type: String
        },
        icon: {
            type: String
        },
        disabled: {
            type: Boolean,
            default: false
        },
        flex: {
            type: Boolean,
            default: true
        },
        active: {
            type: Boolean,
            default: false
        }
    }
};

</script>

<style lang="scss" scoped>
    .btn.action-btn {
        background-color: transparent;
        margin: 10px 10px;
        padding: 5px;
        cursor: pointer;
        border-radius: 5px;
        font-size: 1em;
        .action-icon {
            height: auto;
            margin-left: 10px;
            color: white;
        }
        
        &.state-active {
            border-bottom: 3px solid #fff;
            outline: none;
        }
        
        &:hover {
            filter: invert(20%);
        }
        
        &:active, &:focus {
            outline: none;
        }
        
        .button-title {
            color: white;
            text-align: center;
            margin: 0;
            padding: 0;
        }
    }
</style>
